import React from 'react'
import { DataManagementGrid } from '../Common/DataManagementGrid'
import { instructorColumns } from '../../Data/InstructorManagement/InstructorListData'
import { getAllData } from '../../lib/instructorinfo'
import { useDataManagement } from '../../Hooks/useDataManagement'
import { useLayout } from '../../Hooks/useLayout'
import { useRoleBasedUrl } from '../../Hooks/useRoleBasedUrl'

const AdminInstructorList = () => {
	const layout = useLayout()
	const role = useRoleBasedUrl()

	const { data: instructors, loading, searchQuery, setSearchQuery } = useDataManagement(getAllData)

	// Sort instructors by name
	const sortedInstructors = React.useMemo(() => {
		return [...instructors].sort((a, b) => {
			const nameA = a.name ? a.name : ''
			const nameB = b.name ? b.name : ''
			return nameA.localeCompare(nameB)
		})
	}, [instructors])

	return (
		<DataManagementGrid
			title="Instructor Management"
			subTitle="Manage all instructors in the system"
			breadcrumbTitle="Instructor Management"
			breadcrumbMainTitle="Instructor Management"
			columns={(layout, role) => instructorColumns(layout, role)}
			data={sortedInstructors}
			loading={loading}
			searchQuery={searchQuery}
			setSearchQuery={setSearchQuery}
			searchPlaceholder="Search by name, email, phone, or status..."
			createButtonText="Create New Instructor"
			createButtonLink={`${process.env.PUBLIC_URL}/${role}/instructors/create/${layout}`}
			searchFields={['name', 'surname', 'email', 'phone', 'isActive']}
			noDataMessage="No instructors found"
		/>
	)
}

export { AdminInstructorList }
